import { jsx as _jsx } from "react/jsx-runtime";
import { isClassDerivedDeviceEnabledType } from '@iotv/datamodel';
import { Stack, Typography } from '@mui/material';
import { Sparklines, SparklinesBars, SparklinesLine } from 'react-sparklines';
export const getAttributeSparkLineRenderer = (k) => (p) => {
    if (isClassDerivedDeviceEnabledType(p.row.contextObject)) {
        const { row: { dailyReadings, hourlyReadings, id, readingsAttributeKey }, } = p;
        const rawData = k === 'dailyReadings'
            ? dailyReadings
                ? (dailyReadings[readingsAttributeKey || 'never'] ?? [])
                : []
            : hourlyReadings
                ? (hourlyReadings[readingsAttributeKey || 'never'] ?? [])
                : [];
        // Trim leading/trailing zeros — they are uninitialized sentinel values, not real readings.
        // Interior zeros are preserved as they may be valid for some series types.
        const firstReal = rawData.findIndex((v) => v !== 0);
        const lastReal = rawData.length - 1 - [...rawData].reverse().findIndex((v) => v !== 0);
        const data = firstReal === -1 ? [] : rawData.slice(firstReal, lastReal + 1);
        const hasData = data.length > 0;
        const hasSeries = data.length > 1;
        return (_jsx(Stack, { children: hasData ? (_jsx(Sparklines, { data, height: 25, children: hasSeries ? _jsx(SparklinesBars, { barWidth: 5 }) : _jsx(SparklinesLine, {}) }, id)) : (_jsx(Typography, { variant: 'caption', color: 'text.secondary', justifyContent: 'center', alignItems: 'center', children: "No data" })) }));
    }
    else {
        return null;
    }
};
